export const SkeletorSymbol = Symbol("skeletor")

export const DEFAULT_OPTIONS = {
  shimmer: true,
}
